import jwt_decode from "jwt-decode";

export const getDecodedToken = () => {
  try {
    const token = localStorage.getItem("token");
    if (!token) return null;
    return jwt_decode(token);
  } catch (error) {
    console.error("Failed to decode auth token:", error);
    return null;
  }
};

export const getUserRole = () => {
  const decoded = getDecodedToken();
  return decoded?.role || null;
};

/**
 * @param {string|null|undefined} requiredRole - if falsy, authorization check is skipped
 */
export const hasRequiredRole = (requiredRole) => {
  if (!requiredRole) return true;
  return getUserRole() === requiredRole;
};
